<template>
  <div class="forgetModal">
    <div class="box">
      <div class="tilte">
        <h2>找回密码</h2>
      </div>
      <div class="form">
        <a-form
          :form="form"
          ref="form"
        >
          <a-form-item>
            <a-input
              v-decorator="[
                'phone',
                { rules: [{ required: true, message: '请输入手机号' },{validator:validatorName}] },
              ]"
              placeholder="请输入手机号"
            >
              <a-icon
                slot="prefix"
                type="phone"
                style="color:rgba(0,0,0,.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item class="iteminp">
            <a-input
              class="cadeinp"
              v-decorator="[
                'captcha',
                { rules: [{ required: true, message: '请输入验证码' },{validator:validatorcaptcha}] },
              ]"
              placeholder="请输入短信验证码"
            >
              <a-icon
                slot="prefix"
                style="color:rgba(0,0,0,.25)"
              />
            </a-input>
            <a-button
              v-if="show"
              class="subbtn"
              @click="gocade"
            >
              <span>获取验证码</span>
            </a-button>
            <a-button
              v-if="!show"
              class="subbtn"
            >
              <span class="count">{{count}}s</span>
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
                'pwd',
                { rules: [{ required: true, message: '请输入新密码' },{validator:validatorPwd}] },
              ]"
              type="password"
              placeholder="请输入8-16位新密码，区分大小写"
            >
              <a-icon
                slot="prefix"
                type="lock"
                style="color:rgba(0,0,0,.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
                'repwd',
                { rules: [{ required: true, message: '请确认新密码' },{validator:validatorrePwd}] },
              ]"
              type="password"
              placeholder="确认新密码"
            >
              <a-icon
                slot="prefix"
                type="lock"
                style="color:rgba(0,0,0,.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              @click="sule"
            >
              确认修改
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div
      class="sureModal"
      v-show="flag"
    >
      <div class="surebox">
        <div class="header"></div>
        <div class="tishi">
          <p class="tag">
            <img
              src="../assets/register/chenggong.png"
              alt=""
            >
            <span>修改成功</span>
          </p>
          <div
            class="close"
            @click="closeModal"
          >X</div>
        </div>
        <div class="content">
          <p>密码修改成功，请重新登录。</p>
          <button
            class="logbtn"
            @click="gologin"
          >去登录</button>
        </div>
      </div>
    </div>
    <loginModal
      :isShow="isShow"
      @closemodal="isShow=false"
      @goregister="goregister"
      @forget="forget"
    ></loginModal>
  </div>
</template>
<script>
import { getcodeApi, forgetApi } from "@/request/api";
import loginModal from "@/components/common/loginModal";
export default {
  name: "forgetModal",
  components: { loginModal },
  data() {
    let validatorName = (rule, value, callback) => {
      var regphone = /^1[3456789]\d{9}$/;
      if (value == "" || regphone.test(value)) {
        this.phone = value;
        callback();
      } else {
        callback(new Error("请输入正确格式的手机号"));
      }
    };

    let validatorPwd = (rule, value, callback) => {
      var regpwd = /^[\w$]{8,16}$/; //所有字符验证
      if (value == "" || regpwd.test(value)) {
        this.pwd = value;
        callback();
      } else {
        callback(new Error("密码格式错误，请输入8到16位密码，区分大小写"));
      }
    };
    let validatorcaptcha = (rule, value) => {
      this.captcha = value;
    };
    let validatorrePwd = (rule, value, callback) => {
      if (value == this.pwd) {
        callback();
      } else {
        callback(new Error("两次密码不一致"));
      }
    };
    return {
      form: this.$form.createForm(this, { name: "horizontal_login" }),
      validatorName,
      validatorPwd,
      validatorrePwd,
      validatorcaptcha,
      pwd: "",
      captcha: "",
      phone: "",
      flag: false,
      show: true,
      timer: "",
      count: "",
      isShow:false
    };
  },
  methods: {
    gocade() {
      if (this.phone) {
        this.getToken(getcodeApi, { telephone: this.phone }, (res) => {
          if (res.code == 200) {
            this.$message.info("验证码已发送，请注意查收！");
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }
        });
      } else {
        this.$message.error("请输入手机号");
      }
    },
    sule() {
      if (this.phone) {
        if (this.pwd) {
          this.getToken(
            forgetApi,
            { telephone: this.phone, captcha: this.captcha, newPwd: this.pwd },
            (res) => {
              if (res.code == 200) {
                this.flag = true;
              }
            }
          );
        } else {
          this.$message.error("密码不能为空");
        }
      } else {
        this.$message.error("手机号不能为空！");
      }
    },
    gologin() {
      this.flag = false;
      this.isShow = true;
    },
    closeModal() {
      this.flag = false;
    },
    goregister() {
      this.$router.push({ path: "/register" }); //点击登录页的去注册
      this.isShow = false;
    },
    forget() {
      this.$router.push({ path: "/forgetModal" });
      this.isShow = false;
    },
  },
  // ant-form-explain   错误提示的展示内容
};
</script>

<style lang="stylus" scoped>
.forgetModal {
  background: #eee;
  overflow: hidden;

  .box {
    margin: 0 auto;
    margin-top: 60px;
    width: 1030px;
    min-height: 588px;
    background-color: #ffffff;
    //background:pink;
    margin-bottom: 50px;

    .tilte {
      margin: 0 auto;
      height: 70px;

      h2 {
        font-size: 28px;
        line-height: 70px;
        letter-spacing: 0px;
        color: #414141;
        text-align: center;
        width: 928px;
        margin: 0 auto;
        border-bottom: 1px solid #ddd;
      }
    }

    .form {
      width: 425px;
      margin: 0 auto;
      margin-top: 60px;

      .ant-btn-primary {
        height: 40px;
        width: 425px;
        background-color: #f0cd48;
        border-radius: 3px;
        font-size: 16px;
        border: 0;
        color:#333;
      }
    }

    .ant-input-affix-wrapper {
      line-height: 45px;
      height: 45px;

      .ant-input-prefix {
        font-size: 16px;
        top: 39px;
        position: relative;
      }
    }

    .iteminp {
      display: flex;

      .cadeinp {
        width: 295px;
        margin-right: 10px;
      }

      .subbtn {
        width: 118px;
        height: 45px;
        line-height: 45px;
        background: #ffffff;
        border-radius: 3px;
        border: solid 1px #ef9545;
        color: #ef9545;
        outline: none;

        .count {
          color: red;
        }
      }
    }
  }
}

.sureModal {
  position: relative;
  z-index: 999;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background: rgba(0, 0, 0, 0.5);

  .surebox {
    width: 489px;
    height: 246px;
    background-color: #ffffff;
    border-radius: 3px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .header {
    width: 100%;
    height: 5px;
    background-color: #0096ff;
    border-radius: 3px;
  }

  .tishi {
    margin: 0 auto;

    .tag {
      margin: 0 auto;
      width: 420px;
      border-bottom: 1px solid #dfdfdf;
      height: 70px;
      line-height: 70px;
      display: flex;
      align-items: center;
      position: relative;
      span:nth-child(1) {
        width: 32px;
        height: 33px;
        color: #fff;
        display: block;
        border-radius: 50%;
        font-size: 20px;
        text-align: center;
        background-color: #0096ff;
        line-height: 33px;
      }

      span:nth-child(2) {
        color: #666666;
        font-size: 18px;
        padding-left: 11px;
      }
    }

    .close {
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      color: #999;
      font-size: 22px;
      position: absolute;
      right: 15px;
      top: 15px;
      cursor: pointer;
    }
  }

  .content {
    p {
      width: 420px;
      margin: 0 auto;
      padding-top: 40px;
      font-size: 16px;
    }

    .logbtn {
      width: 108px;
      height: 36px;
      background-color: #f0cd48;
      border-radius: 3px;
      color: #fff;
      border: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      outline: none;
      font-size: 16px;
      position: absolute;
      right: 35px;
      bottom: 25px;
    }
  }
}
</style>
